<ng-container *ngIf="isLastPage() && (globals.OFFLINE || allowRestart())">
  <button href role="button" class="btn btn-secondary"
    (click)="startNewSurvey()">
    <fa-icon [icon]="['fas', 'sync']"></fa-icon>
    {{ 'Start a new survey' | wsTrans: 'wsapp_start_new_survey'|async }}
  </button>
</ng-container>
